import { render, staticRenderFns } from "./VisualAnalysisTable.vue?vue&type=template&id=90b9fe4c&scoped=true&"
import script from "./VisualAnalysisTable.vue?vue&type=script&lang=ts&"
export * from "./VisualAnalysisTable.vue?vue&type=script&lang=ts&"
import style0 from "./VisualAnalysisTable.vue?vue&type=style&index=0&id=90b9fe4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b9fe4c",
  null
  
)

export default component.exports